import { FaRegUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { useLanguage } from '../../../../../../_CORE/Contexts/Translate/useLanguageContext';
import { useNavigate } from 'react-router-dom';
import { useHeaderUtilities } from '../_Hooks/useHeaderUtilities';
import { UtilityDropdown, UtilityItem, UtilityAction } from '../UtilityDropdown';

const onResolveAccountLabel = (user, fallback) => {
    const DATA = user?.data ?? user ?? {};
    const EMAIL = String(DATA?.email ?? '').trim().toLowerCase();

    const FULL_NAME = [DATA?.firstName, DATA?.lastName]
        .map((value) => String(value ?? '').trim())
        .filter(Boolean)
        .join(' ');

    const CANDIDATES = [DATA?.name, DATA?.displayName, DATA?.fullName, FULL_NAME]
        .map((value) => String(value ?? '').trim())
        .filter(Boolean);

    const NAME = CANDIDATES.find((value) => value.toLowerCase() !== EMAIL);

    return NAME || fallback;
};

export const Profile = ({ user = null, links = [], onClickLogout }) => {

    const navigate = useNavigate();

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.header ?? {};

    const { onClose } = useHeaderUtilities();

    const ACCOUNT_LABEL = onResolveAccountLabel(user, TEXT.accountFallback ?? 'Cuenta');
    const LOGOUT_LABEL = String(TEXT.logout ?? 'Cerrar sesión').trim() || 'Cerrar sesión';
    const USER_DATA = user?.data ?? user ?? {};
    const AVATAR = String(USER_DATA?.avatar ?? '').trim();

    const onGoTo = (path) => { onClose(); navigate(path); };

    const onLogout = () => {
        onClose();
        if (typeof onClickLogout === 'function') onClickLogout();
    };

    return (
        <UtilityDropdown
            id="profile"
            label={ACCOUNT_LABEL}
            width={260}
            icon={AVATAR ? <img className="LStudio__app_utility__avatar" src={AVATAR} alt="" /> : <FaRegUserCircle size={18} />}
            footer={(
                <UtilityAction onClick={onLogout} isDanger>
                    <span className="SDProfileLogoutAction">
                        <FaSignOutAlt aria-hidden="true" />
                        <span>{LOGOUT_LABEL}</span>
                    </span>
                </UtilityAction>
            )}
        >
            {
                links.map((link) => (
                    <UtilityItem key={link.path} title={link.label}
                        onClick={() => onGoTo(link.path)} />
                ))
            }
        </UtilityDropdown>
    );
};
